import { Link, useParams } from 'react-router-dom';
import { ArrowLeft, MessageCircle } from 'lucide-react';
import BlogLayout from './BlogLayout';
import { BLOG_POSTS, getBlogPost } from '../data/blogPosts';
import { openSalesIQChat } from '../utils/chat';

function BlogPostPage() {
  const { slug } = useParams();
  const post = getBlogPost(slug);

  if (!post) {
    return (
      <BlogLayout>
        <section className="t5-section">
          <div className="t5-wrap blog-not-found">
            <h1>Article not found</h1>
            <p>The guide you requested is not available. Browse our Family Tree Maker resources instead.</p>
            <Link to="/blog" className="t5-btn t5-btn--solid">
              View all articles
            </Link>
          </div>
        </section>
      </BlogLayout>
    );
  }

  const related = BLOG_POSTS.filter((p) => p.slug !== post.slug).slice(0, 3);

  return (
    <BlogLayout>
      <article className="blog-article">
        <header className="blog-article__hero">
          <div className="t5-wrap">
            <Link to="/#blog" className="blog-back-link">
              <ArrowLeft size={16} aria-hidden />
              All resources
            </Link>
            <span className="t5-kicker">{post.topic}</span>
            <h1>{post.title}</h1>
            <p className="blog-article__excerpt">{post.excerpt}</p>
            <p className="blog-article__meta">
              <time dateTime={post.date}>{post.date}</time>
              <span aria-hidden> · </span>
              {post.readTime}
            </p>
          </div>
        </header>

        <div className="t5-wrap blog-article__content-wrap">
          <div className="blog-article__content">
            {post.content.map((paragraph, i) => (
              <p key={i}>{paragraph}</p>
            ))}
          </div>

          <div className="blog-article__cta">
            <h2>Want help on your tree?</h2>
            <p>Open live chat and tell us your version, OS, and what you already tried—we will walk through it with you.</p>
            <button type="button" className="t5-btn t5-btn--solid" onClick={openSalesIQChat}>
              <MessageCircle size={20} aria-hidden />
              Start live chat
            </button>
          </div>

          {related.length > 0 && (
            <aside className="blog-related">
              <h2>More guides</h2>
              <ul>
                {related.map((item) => (
                  <li key={item.slug}>
                    <Link to={`/blog/${item.slug}`}>{item.title}</Link>
                    <span>{item.readTime}</span>
                  </li>
                ))}
              </ul>
            </aside>
          )}
        </div>
      </article>
    </BlogLayout>
  );
}

export default BlogPostPage;
